export const GET_DISCORD_INFO = "GET_DISCORD_INFO";
export const GET_DISCORD_INFO_SUCCESS = "GET_DISCORD_INFO_SUCCESS";
export const GET_DISCORD_INFO_ERROR = "GET_DISCORD_INFO_ERROR";

export const getDiscordInfo = () => ({
  type: GET_DISCORD_INFO,
});

export const getDiscordInfoSuccess = (payload) => ({
  type: GET_DISCORD_INFO_SUCCESS,
  payload,
});

export const getDiscordInfoError = (payload) => ({
  type: GET_DISCORD_INFO_ERROR,
  payload,
});
